type Segment = {
  start: number;
  end: number;
  speaker: number;
  items: any[];
};

type Caption = {
  id: number;
  start: string;
  end: string;
  text: string;
};

type SpeakerBlock = {
  speaker: number;
  start: string;
  end: string;
  sentences: string[];
};

export function parseSegments(text: string): Segment[] {
  return text
    .split('\n')
    .filter(Boolean)
    .map((line) => JSON.parse(line));
}

function formatTime(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}

function buildText(items: any[]): string {
  return items
    .map((item) => (Array.isArray(item) ? item[0] : item))
    .join(' ')
    .replace(/\s+([.,!?])/g, '$1');
}

export function buildCaptions(segments: Segment[]): Caption[] {
  return segments.map((seg, index) => ({
    id: index + 1,
    start: formatTime(seg.start),
    end: formatTime(seg.end),
    text: buildText(seg.items)
  }));
}
export function buildTranscript(segments: Segment[]): SpeakerBlock[] {
  const result: SpeakerBlock[] = [];
  let current: SpeakerBlock | null = null;

  segments.forEach((seg) => {
    const text = buildText(seg.items);

    const sentences = text.split(/(?<=[.!?])\s+/);

    if (!current || current.speaker !== seg.speaker) {
      if (current) result.push(current);

      current = {
        speaker: seg.speaker,
        start: formatTime(seg.start),
        end: formatTime(seg.end),
        sentences
      };
    } else {
      current.sentences.push(...sentences);
      current.end = formatTime(seg.end);
    }
  });

  if (current) result.push(current);

  return result;
}
